import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-four',
  templateUrl: './pricing-four.component.html',
  styleUrls: ['./pricing-four.component.css']
})
export class PricingFourComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
